module.exports = __webpack_public_path__ + "static/media/banescoLogoB&WBG.cd8827c0.svg";